module.exports = __webpack_public_path__ + "static/venice20898-0e6aa889965f1a4b115c8e384f1afb34.png";